<template>
	<div class="container">
		<img class="back_ground_img" src="@/assets/background.png"/>
		<img class="logo" src="@/assets/galaku_logo.png"/>
		<div class="title title1">关注</div>
		<div class="title title2">微信公众号</div>
		<div class="title_small">关注我们，了解最新动态。</div>
		<div class="menu-container">
			<img class="qr_code" @click="qrCodeClick" src="@/assets/qrcode1.jpg"/>
			<div class="right_part">
				<div class="menu_title">GALAKU Pro</div>
				<div class="menu_sub_title">大型活动发布</div>
				<div class="menu_sub_title">重大事件通知</div>
				<div class="menu_sub_title">APP下载入口</div>
			</div>
		</div>
		
		<div class="menu-container2">
			<img class="qr_code" @click="qrCode2Click" src="@/assets/qrcode2.jpg"/>
			<div class="right_part">
				<div class="menu_title">GALAKU 官方</div>
				<div class="menu_sub_title">大型活动发布</div>
				<div class="menu_sub_title">重大事件通知</div>
				<div class="menu_sub_title">APP下载入口</div>
			</div>
		</div>
		
	</div>
</template>


<script>
	
import Vue from 'vue'
import axios from 'axios'

var wx = require('weixin-js-sdk');

export default {
  name: 'app',
  components: {
  },
  
  data(){
	  return{
		  barWidth:0,
		  progressWidth:0,
		  isApkDownloaded:false,
		  filePath:""
	  }
  },
  
  computed:{
  },
  
 
  mounted() {
	  // const width = this.$refs.barRef.offsetWidth;
	  // const height = this.$refs.barRef.offsetHeight;
	  
	  // console.log("width:"+width);
	  // console.log("height:"+height);
	  
	  // this.$data.barWidth = width;
  },
  
  
  beforeDestroy() {
  },
  
  created() {
		// window.addEventListener('beforeunload', e => this.beforeunloadFn(e))
	// 扩展API是否准备好，如果没有则监听“plusready"事件
  },
  
  destroyed() {
		window.removeEventListener('beforeunload', e => this.beforeunloadFn(e))
  },
  
 
  methods:{
		beforeunloadFn(e) {
			console.log('刷新或关闭')
		}, 
		
		qrCodeClick(e){
 			console.log(e);
  			var url = e.target.src;
  			console.log("url:"+url);
  			var current = url;
  			var urls = [];
  			urls.push(current);
  			wx.previewImage({
  				current:current,
  				urls:urls
  			});
		},
		
		qrCode2Click(e){
			console.log(e);
			var url = e.target.src;
			console.log("url:"+url);
			var current = url;
			var urls = [];
			urls.push(current);
			wx.previewImage({
				current:current,
				urls:urls
			});
		}

	}

}
</script>

<style>
	#app {
	/*  font-family: 'Avenir', Helvetica, Arial, sans-serif;
	  -webkit-font-smoothing: antialiased;
	  -moz-osx-font-smoothing: grayscale;
	  text-align: center;
	  color: #2c3e50;
	  margin-top: 60px; */
	  padding: 0;
	  margin: 0;
	}

	.container{
		padding: 0;
		margin: 0;
		height: 100vh;
		width: 100vw;
		position: relative;
	}
	
	.back_ground_img{
		position: absolute;
		left: 0;
		top: 0;
		height: 100vh;
		width: 100vw;
		z-index: -100;
	}
	
	.logo{
		margin-left: 20px;
		margin-top: 20%;
		width: 50px;
		height: 50px;
	}
	
	.title{
		margin-left: 20px;
		font-size: 70px;
		color: black;
		font-weight:bolder
	}
	
	.title1{
		margin-top: 20px;
	}
	
	.title2{
		margin-top: -15px;
	}
	
	.title_small{
		margin-left: 20px;
		font-size: 22px;
		color: #333333;
		margin-top: 10px;
	}
	
	.menu-container{
		margin-left: 20px;
		width: calc(100vw - 40px);
		height: 120px;
		display: flex;
		align-items: center;
		margin-top: 50px;
		border-radius: 23px;
		background:linear-gradient(to bottom, #ffffff, #DBE0FF);
	}
	
	.qr_code{
		width: 90px;
		height: 90px;
		margin-left: 15px;
	}
	
	.right_part{
		flex: 1 1 auto;
		height: 100%;
		margin-left: 15px;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}
	
	.menu_title{
		font-size: 23px;
		color: black;
		font-weight: bold;
	}
	
	.menu_sub_title{
		font-size: 13px;
		color: #333333;
	}
	
	.menu-container2{
		margin-left: 20px;
		width: calc(100vw - 40px);
		height: 120px;
		display: flex;
		align-items: center;
		margin-top: 20px;
		border-radius: 23px;
		background:linear-gradient(to bottom, #ffffff, #DBE0FF);
	}

</style>
